import styled from 'styled-components';
import Card from '@bexs/dollar/components/Card';

export const CardFilter = styled(Card)`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9;
  width: 100%;
  max-width: 482px;
  height: auto;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const FormFilter = styled.form`
  display: grid;
  align-items: center;
  grid-template-columns: 140px 1fr;
  gap: 24px;
`;

export const CardFilterClose = styled.button.attrs({
  type: 'button',
})`
  background-color: transparent;
  padding: 0;
  border: 0;
  cursor: pointer;
  font-size: 1.125rem;
  svg {
    margin: 0;
  }
`;
